__turbopack_context__.v({
  "container": "PageLoader-module__sHxxiG__container",
});
